export const YES: RuleOutput = 'Yes';
export const NO: RuleOutput = 'No';
export const NOT_APPLICABLE: RuleOutput = 'NotApplicable';